import { useContext, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { IntlContext } from '@/i18n';
import { TMake } from '@src-common/api/definitions/w4d-cars-types';

import { formatEngine } from '../engine';

import { useModelConfig } from './useModelConfig';

export const useEngines = (make?: TMake, model?: string) => {
  const intl = useIntl();
  const { region } = useContext(IntlContext);

  const modelConfig = useModelConfig(make, model);

  return useMemo(() => {
    if (!modelConfig || !model) {
      return [];
    }

    return modelConfig.engines.map(engine => ({
      title: formatEngine(engine, intl, region) ?? engine,
      value: engine,
    }));
  }, [intl, modelConfig, model, region]);
};
